import { createFileRoute } from "@tanstack/react-router";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PageHeader } from "@/components/layout/page";
import { Breadcrumbs } from "@/components/nav/breadcrumbs";
import { CodeBlock } from "@/components/display/code-block";
import { JsonViewer } from "@/components/display/json-viewer";
import { LoadingState, ErrorState } from "@/components/feedback/states";
import { API_BASE } from "@/lib/http";
import { useIngestEndpoint } from "@/api/endpoints";

export const Route = createFileRoute("/_app/endpoints/ingest/$id")({
  component: IngestDetail,
});

function IngestDetail() {
  const { id } = Route.useParams();
  const { data: e, isLoading, error, refetch } = useIngestEndpoint(id);

  if (isLoading) return <LoadingState />;
  if (error || !e) return <ErrorState error={error ?? "Not found"} onRetry={() => refetch()} />;

  const base = API_BASE.replace(/\/api$/, "");
  const curl = `curl -X POST "${base}/api/v1/external/ingest/${e.slug}" \\
  -H "X-API-Key: udip_..." \\
  -H "Content-Type: application/json" \\
  -d '[{ ${(e.schema ?? []).map((c) => `"${String(c.name ?? "field")}": "…"`).join(", ")} }]'`;

  return (
    <Stack spacing={3}>
      <PageHeader
        title={e.name}
        breadcrumbs={
          <Breadcrumbs
            items={[
              { label: "Endpoints", to: "/endpoints" },
              { label: "Ingest", to: "/endpoints/ingest" },
              { label: e.name },
            ]}
          />
        }
        description={e.description ?? undefined}
      />
      <Card sx={{ p: 2 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Schema
        </Typography>
        <JsonViewer value={e.schema ?? []} />
      </Card>
      <Card sx={{ p: 2 }}>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Push data
        </Typography>
        <CodeBlock code={curl} language="bash" />
      </Card>
    </Stack>
  );
}
